import isAfter from 'date-fns/isAfter'

export function getView(booking) {
  return booking && isAfter(Date.parse(`${booking.start_time}Z`), new Date())
    ? 'Future'
    : 'Past'
}
